// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { WarningStatusIcon } from '@/constants/hardfin-standard-icons';
import { pluralize } from '@/utilities/pluralize';
import { Chip, Skeleton } from '@mui/material';

type QuarantinedFilterChipBaseProps = {
  isActive: boolean;
  onClick: () => void;
} & (
  | {
      countStatus: 'loading';
      quarantinedCount?: never;
    }
  | {
      countStatus: 'loaded';
      quarantinedCount: number;
    }
);

export function QuarantinedFilterChipBase(
  props: QuarantinedFilterChipBaseProps
) {
  const hasQuarantinedCount =
    props.countStatus === 'loaded' && props.quarantinedCount > 0;

  const label =
    props.countStatus === 'loading' ? (
      <Skeleton width={110} />
    ) : (
      pluralize(props.quarantinedCount, {
        singular: 'with quarantine',
        plural: 'with quarantine',
      })
    );

  return (
    <Chip
      clickable
      icon={hasQuarantinedCount ? <WarningStatusIcon /> : undefined}
      color={hasQuarantinedCount ? 'warning' : 'default'}
      variant={props.isActive ? 'filled' : 'outlined'}
      label={label}
      onClick={props.onClick}
      onDelete={props.isActive ? props.onClick : undefined}
      aria-pressed={props.isActive}
    />
  );
}
